import React from "react";
import LandingComponent from '../Components/Landing/Landing'

function Landing() {
  return (
    <LandingComponent />
  );
}

export default Landing;
